import { CalendarRange, Percent, IndianRupee, FolderKanban, Building2 } from "lucide-react";

const Badge = ({ icon: Icon, children, title }) => (
    <span
        title={title}
        className="
            inline-flex
            items-center
            gap-1
            max-w-[220px]
            px-2
            py-0.5
            rounded-full
            bg-[#EEF4FF]
            text-[#3538CD]
            text-[14px]
            font-medium
            whitespace-nowrap
        "
    >
        <Icon size={11} className="flex-shrink-0" />
        <span className="truncate">{children}</span>
    </span>
);

/**
 * Small pill row summarising the filters currently applied to a chart, e.g.
 * [FY 2026-2027] [Percentage] [Project: NTPC LARA STPP STAGE-II]. Shared by
 * UnitWiseCostBarChart, UnitWiseCostDoughnutChart and ProjectWiseCostBarChart
 * so all three read the same filter state consistently.
 *
 * `unitLabel` is optional - only ProjectWiseCostBarChart has a Unit filter,
 * so it's omitted (no badge rendered) by the other two charts.
 */
const ChartFilterBadges = ({ fyLabel, valueMode, valueModeLabel, projectNames = [], unitLabel }) => {
    const ValueModeIcon = valueMode === "CRORE" ? IndianRupee : Percent;

    return (
        <div className="flex flex-wrap items-center gap-1.5 mt-1">
            <Badge icon={CalendarRange}>{fyLabel}</Badge>
            <Badge icon={ValueModeIcon}>{valueModeLabel}</Badge>

            {unitLabel && (
                <Badge icon={Building2} title={unitLabel}>
                    {unitLabel}
                </Badge>
            )}

            {projectNames.length === 1 && (
                <Badge icon={FolderKanban} title={projectNames[0]}>
                    {projectNames[0]}
                </Badge>
            )}

            {projectNames.length > 1 && (
                <Badge icon={FolderKanban} title={projectNames.join(", ")}>
                    {projectNames.length} Projects
                </Badge>
            )}
        </div>
    );
};

export default ChartFilterBadges;
